import { message } from "antd";
import { apiBase } from "../utils/apiBase";
import { get } from "lodash";

export const types = {
  CALL_VOICEMAILS_SET: "CALL_VOICEMAILS_SET",
  CALL_VOICEMAILS_SET_LOADING: "CALL_VOICEMAILS_SET_LOADING",
  CALL_VOICEMAILS_SET_NEXT: "CALL_VOICEMAILS_SET_NEXT",
};

export const setCallVoicemails = (value) => ({
  type: types.CALL_VOICEMAILS_SET,
  value,
});

export const setLoading = (value) => ({
  type: types.CALL_VOICEMAILS_SET_LOADING,
  value,
});

export const setNextVoicemail = (value) => ({
  type: types.CALL_VOICEMAILS_SET_NEXT,
  value,
});

export const getCallVoicemails = () => (dispatch) => {
  dispatch(setLoading(true));
  return apiBase
    .get(`call-voicemails`)
    .then((res) => {
      const voicemails = get(res, "data.call_voicemails", []);
      dispatch(setCallVoicemails(voicemails));
      dispatch(setLoading(false));
      return voicemails;
    })
    .catch((err) => {
      dispatch(setCallVoicemails([]));
      dispatch(setLoading(false));
      message.error("Failed to load call voicemails.");
      return [];
    });
};

export const getNextVoicemail = (phoneNumber, twilioNumberId) => (dispatch) => {
  return apiBase
    .get(`call-voicemails/next`, { params: { phoneNumber, twilioNumberId } })
    .then((res) => {
      dispatch(setNextVoicemail(res.data));
      return res.data;
    })
    .catch((err) => {
      dispatch(
        setNextVoicemail({
          nextVoicemail: null,
          droppedCount: 0,
          totalActive: 0,
        })
      );
      return null;
    });
};

export const createCallVoicemail = (data) => (dispatch, getState) => {
  return apiBase
    .post(`call-voicemails`, data)
    .then((res) => {
      const newVoicemail = get(res, "data.call_voicemail", null);
      if (newVoicemail) {
        const { data: currentVoicemails } = getState().callVoicemails;
        const updatedVoicemails = [...currentVoicemails, newVoicemail].sort(
          (a, b) => (a.order ?? Infinity) - (b.order ?? Infinity)
        );
        dispatch(setCallVoicemails(updatedVoicemails));
        message.success("Call voicemail created");
      }
      return newVoicemail;
    })
    .catch((err) => {
      const errorMsg = get(
        err,
        "response.data.error",
        "Failed to create call voicemail"
      );
      message.error(errorMsg);
      return null;
    });
};

export const updateCallVoicemail = (id, data) => (dispatch, getState) => {
  return apiBase
    .patch(`call-voicemails/${id}`, data)
    .then((res) => {
      const updatedVoicemail = get(res, "data.call_voicemail", null);
      if (updatedVoicemail) {
        const { data: currentVoicemails } = getState().callVoicemails;
        const updatedVoicemails = currentVoicemails
          .map((voicemail) =>
            voicemail.id === updatedVoicemail.id ? updatedVoicemail : voicemail
          )
          .sort((a, b) => (a.order ?? Infinity) - (b.order ?? Infinity));
        dispatch(setCallVoicemails(updatedVoicemails));
        message.success("Call voicemail updated");
      }
      return updatedVoicemail;
    })
    .catch((err) => {
      const errorMsg = get(
        err,
        "response.data.error",
        "Failed to update call voicemail"
      );
      message.error(errorMsg);
      return null;
    });
};

export const deleteCallVoicemail = (id) => (dispatch, getState) => {
  return apiBase
    .delete(`call-voicemails/${id}`)
    .then((res) => {
      const { data: currentVoicemails } = getState().callVoicemails;
      const updatedVoicemails = currentVoicemails.filter(
        (voicemail) => voicemail.id !== id
      );
      dispatch(setCallVoicemails(updatedVoicemails));
      message.success("Call voicemail deleted");
      return true;
    })
    .catch((err) => {
      const errorMsg = get(
        err,
        "response.data.error",
        "Failed to delete call voicemail"
      );
      message.error(errorMsg);
      return false;
    });
};

export const getUploadUrl = (key) => {
  return apiBase
    .post(`call-voicemails/upload-url`, { key })
    .then((res) => res.data)
    .catch((err) => {
      message.error("Failed to get upload URL");
      return null;
    });
};

export const initialState = {
  data: [],
  loading: false,
  nextVoicemail: null,
};

export function reducer(state = initialState, action) {
  switch (action.type) {
    case types.CALL_VOICEMAILS_SET:
      return { ...state, data: action.value };
    case types.CALL_VOICEMAILS_SET_LOADING:
      return { ...state, loading: action.value };
    case types.CALL_VOICEMAILS_SET_NEXT:
      return { ...state, nextVoicemail: action.value };
    default:
      return state;
  }
}

export default {
  getCallVoicemails,
  createCallVoicemail,
  updateCallVoicemail,
  deleteCallVoicemail,
  getUploadUrl,
  setCallVoicemails,
  setLoading,
  setNextVoicemail,
  getNextVoicemail,
};
